import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { CHART_COLORS } from '@/utils/statisticsFormatters';

interface PlansDistributionChartProps {
  data: { plan: string; count: number; percentage: number }[];
}

const PLAN_LABELS: Record<string, string> = {
  free: 'Free',
  basic: 'Basic',
  pro: 'Pro',
  premium: 'Premium',
};

export const PlansDistributionChart = ({ data }: PlansDistributionChartProps) => {
  const chartData = data.map(item => ({
    name: PLAN_LABELS[item.plan] || item.plan,
    value: item.count,
    percentage: item.percentage,
  }));

  const chartConfig = {
    value: {
      label: 'Usuários',
    },
  };

  const COLORS = [
    CHART_COLORS.plans.free,
    CHART_COLORS.plans.basic,
    CHART_COLORS.plans.pro,
    CHART_COLORS.plans.premium,
  ];

  return (
    <ChartContainer config={chartConfig} className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percentage }) => `${name}: ${percentage.toFixed(1)}%`}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
            animationBegin={0}
            animationDuration={800}
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <ChartTooltip content={<ChartTooltipContent />} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};
